module.exports = __webpack_public_path__ + "img/chatbots_link_key.c9568c81.png";